import { render, staticRenderFns } from "./OurTeamCard.vue?vue&type=template&id=3ae29a7b&"
import script from "./OurTeamCard.vue?vue&type=script&lang=js&"
export * from "./OurTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./OurTeamCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports